import React, { useState, useEffect } from 'react';
import {
  AppBar,
  Toolbar,
  Container,
  Button,
  IconButton,
  Drawer,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  useTheme,
  useMediaQuery,
  Box,
  Stack,
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import HomeIcon from '@mui/icons-material/Home';
import InfoIcon from '@mui/icons-material/Info';
import BusinessCenterIcon from '@mui/icons-material/BusinessCenter';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import PhotoLibraryIcon from '@mui/icons-material/PhotoLibrary';
import ContactsIcon from '@mui/icons-material/Contacts';
import DomainIcon from '@mui/icons-material/Domain';
import PersonIcon from '@mui/icons-material/Person';
import { Link, useLocation } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';
import DashboardIcon from '@mui/icons-material/Dashboard'; 
import BarChartIcon from '@mui/icons-material/BarChart';

const Navbar = () => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [temperature, setTemperature] = useState<number | null>(null);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const location = useLocation();
  const { language, translations } = useLanguage();

  useEffect(() => {
    const fetchTemperature = async () => {
      try {
        const apiKey = 'YOUR_API_KEY'; // replace with your actual API key
        const response = await fetch(`https://api.openweathermap.org/data/2.5/weather?q=Pune&appid=${apiKey}&units=metric`);
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        const data = await response.json();
        setTemperature(data.main.temp);
      } catch (error) {
        console.error('Error fetching temperature:', error);
      }
    };
    fetchTemperature();
  }, []);

  const menuItems = [
    { text: translations.home[language], path: '/', icon: <HomeIcon /> },
    { text: translations.aboutUs[language], path: '/about', icon: <InfoIcon /> },
    // { text: translations.departments[language], path: '/departments', icon: <DomainIcon /> },
    // { text: translations.services[language], path: '/services', icon: <BusinessCenterIcon /> },
    { text: translations.schemes[language], path: '/schemes', icon: <AccountBalanceIcon /> },
    { text: translations.gallery[language], path: '/gallery', icon: <PhotoLibraryIcon /> },
    { text: translations.adarshtakta[language], path: '/adarshtakta', icon: <DashboardIcon /> },
    { text: translations.contact[language], path: '/contact', icon: <ContactsIcon /> },
   // { text: translations.adminLogin[language], path: '/admin', icon: <PersonIcon /> },
   
  ];

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  return (
    <>
      <AppBar 
        position="sticky" 
        color="default" 
        elevation={0}
        sx={{
          backgroundColor: 'white',
          borderBottom: '1px solid',
          borderColor: 'divider',
        }}
      >
        <Container maxWidth="lg">
          <Toolbar sx={{ minHeight: '56px !important' }}>
            {isMobile && (
              <IconButton
                color="inherit"
                aria-label="open drawer"
                edge="start"
                onClick={handleDrawerToggle}
                sx={{ mr: 2 }}
              >
                <MenuIcon />
              </IconButton>
            )}

            {!isMobile && (
              <Stack
                direction="row"
                spacing={1}
                sx={{ width: '100%', justifyContent: 'center' }}
              >
                {menuItems.map((item) => (
                  <Button
                    key={item.text}
                    component={Link}
                    to={item.path}
                    color="inherit"
                    startIcon={item.icon}
                    sx={{
                      px: 3,
                      py: 1.5,
                      position: 'relative',
                      '&::after': {
                        content: '""',
                        position: 'absolute',
                        bottom: 0,
                        left: 0,
                        width: '100%',
                        height: '3px',
                        backgroundColor: 'primary.main',
                        transform: location.pathname === item.path ? 'scaleX(1)' : 'scaleX(0)',
                        transition: 'transform 0.3s ease-in-out',
                      },
                      '&:hover::after': {
                        transform: 'scaleX(1)',
                      },
                    }}
                  >
                    {item.text}
                  </Button>
                ))}
                {temperature !== null && (
                  <Button
                    color="inherit"
                    sx={{
                      px: 3,
                      py: 1.5,
                      position: 'relative',
                      ml: 'auto',
                    }}
                  >
                    Temperature: {temperature}°C
                  </Button>
                )}
              </Stack>
            )}
          </Toolbar>
        </Container>
      </AppBar>

      <Drawer
        variant="temporary"
        anchor="left"
        open={mobileOpen}
        onClose={handleDrawerToggle}
        ModalProps={{ keepMounted: true }}
        sx={{
          '& .MuiDrawer-paper': {
            width: 280,
            backgroundColor: '#00106e',
            color: 'white',
          },
        }}
      >
        {/* <Box sx={{ py: 2, px: 3 }}>
          <img
            src="/pargaonlogo.jpg"
            alt=" Grampanchayat Logo"
            style={{
              width: 80,
              height: 80,
              
            }}
          />
        </Box> */}
        <List>
          {menuItems.map((item) => (
            <ListItem
              button
              component={Link}
              to={item.path}
              key={item.text}
              onClick={handleDrawerToggle}
              selected={location.pathname === item.path}
              sx={{
                my: 0.5,
                mx: 1,
                borderRadius: 1,
                '&.Mui-selected': {
                  backgroundColor: 'rgba(255, 255, 255, 0.1)',
                  '&:hover': {
                    backgroundColor: 'rgba(255, 255, 255, 0.2)',
                  },
                },
                '&:hover': {
                  backgroundColor: 'rgba(255, 255, 255, 0.1)',
                },
              }}
            >
              <ListItemIcon sx={{ color: 'white', minWidth: 40 }}>
                {item.icon}
              </ListItemIcon>
              <ListItemText primary={item.text} />
            </ListItem>
          ))}
        </List>
      </Drawer>
    </>
  );
};

export default Navbar;
